import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { color } from "theme";
import { MEETING_MODE } from "../constants";

const MeetingMode = ({data, setData, dataPeriod}) => {
    const {t} = useTranslation();

    return (
        <FormControl
        id="column-settings-room"
        >
        <RadioGroup
            row
            value={data.meetingMode}
            onChange={(event) =>{
                setData({
                    ...data,
                    meetingMode: parseInt(event.target.value)
                })
            }
            }
        >
            <div style={{ marginRight: "120px" , marginLeft: {xl: "-4px"}}}>
            <FormControlLabel
                tabIndex={0}
                disabled={data.meetingMode === MEETING_MODE.PRIVATE && dataPeriod.isChangePeriod === 1}
                value={0}
                control={<Radio size="small" />}
                label={<span style={{fontWeight: '500'}}>{t('room.room-mode.normal')}</span>}
                sx={{ marginRight: "0", color: color.black, fontWeight: '500' }}
                onKeyUp={(e) => {
                    if(e.code === "Enter") {
                        e.preventDefault();
                        setData({
                            ...data,
                            meetingMode: MEETING_MODE.NORMAL
                        })
                    }
                }}
            />
            </div>
            <div>
            <FormControlLabel
                className="radio-button-padding"
                tabIndex={0}
                disabled={data.meetingMode === MEETING_MODE.NORMAL && dataPeriod.isChangePeriod === 1}
                value={1}
                control={<Radio size="small" />}
                label={<span style={{fontWeight: '500'}}>{t('room.room-mode.private')}</span>}
                sx={{ marginRight: "0", color: color.black, fontWeight: '500' }}
                onKeyUp={(e) => {
                    if(e.code === "Enter"){
                        e.preventDefault();
                        setData({
                            ...data,
                            meetingMode: MEETING_MODE.PRIVATE
                        })
                    }
                }}
            />
            </div>
        </RadioGroup>
        </FormControl>
    );
    };

export default MeetingMode;
